import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { CreateTaskFormActivity } from 'modules/procurement/activities/CreateTaskForm'
import { DuplicateTaskFormActivity } from 'modules/procurement/activities/DuplicateTaskForm'
import { useCreateProcurementTaskForm } from 'modules/procurement/lib/oneHandlers/procurementTaskForm/create-procurement-task-form'

export const manifest = {
  sidebar: (_navigation) => ({
    items: [],
  }),
  activities: {
    createTaskForm: {
      component: CreateTaskFormActivity,
    },
    duplicateTaskForm: {
      component: DuplicateTaskFormActivity,
    },
  },
  one: {
    createActions: {
      taskForm: {
        actionResolver: useCreateProcurementTaskForm,
        policies: ['Procurement_procurementTaskFormCreate'],
      },
    },
  },
} as const satisfies DomainManifest
